import {ElMessage, ElMessageBox} from "element-plus";
import baseUrl from "@/request/base"

const myUtil = {
    //合并两个对象
    mergeObj: (source, target) => {
        for (let key in source){
            if (source.hasOwnProperty(key)){
                target[key] = source[key]
            }
        }

        return target
    },
    //判空
    isEmpty: (value) => {
        if (null == value || "" === value || '' === value || undefined === value)
            return true;
        else
            return false;
    },
    //判非空
    isNotEmpty: (value) => {
        if (null == value || "" === value || '' === value ||undefined === value)
            return false;
        else
            return true;
    },
    //获取小写首字母
    getFirstLetterSmall: (text) => {
        let pinyin = require('js-pinyin');

        pinyin.setOptions({checkPolyphone: false, charCase: 1});

        return pinyin.getCamelChars(text).charAt(0)
    },
    //获取大写首字母list
    getFirstLetterSmallList: (strList) => {
        const letterList = []
        strList.forEach((v, i) => {
            letterList.push(myUtil.getFirstLetterSmall(v))
        })

        return letterList
    },
    //获取大写首字母
    getFirstLetterUppercase: (text) => {
        let pinyin = require('js-pinyin');

        pinyin.setOptions({checkPolyphone: false, charCase: 2});

        return pinyin.getCamelChars(text).charAt(0)
    },
    //获取大写首字母list
    getFirstLetterUppercaseList: (strList) => {
        const letterList = []
        strList.forEach((v, i) => {
            letterList.push(myUtil.getFirstLetterUppercase(v))
        })

        return letterList
    },
    //对象数组按照首字母大写排序
    getFirstLetterUppercaseObj: (objList, attrName = "name") => {
        return myUtil.getFirstLetterObj(objList, attrName, 2)
    },
    //对象数组按照首字母小写排序
    getFirstLetterSmallObj: (objList, attrName = "name") => {
        return myUtil.getFirstLetterObj(objList, attrName, 1)
    },
    getFirstLetterObj: (objList, attrName = "name", tag = 2) => {
        let firstLetterList = []
        const firstLetterObj = {}
        const resultObj = {}

        objList.forEach((v, i) => {
            if (v.hasOwnProperty(attrName)){
                const name = v[attrName]
                let firstLetter = null

                if (tag === 2){
                    firstLetter = myUtil.getFirstLetterUppercase(name)
                }else{
                    firstLetter = myUtil.getFirstLetterSmall(name)
                }

                if (!firstLetterObj.hasOwnProperty(firstLetter)){
                    firstLetterObj[firstLetter] = []
                    firstLetterList.push(firstLetter)
                }

                firstLetterObj[firstLetter].push(v)
            }
        })

        if (firstLetterList.length > 0){
            firstLetterList = firstLetterList.sort()
        }

        firstLetterList.forEach((v, i) => {
            resultObj[v] = firstLetterObj[v]
        })

        return resultObj
    },
    //生成禁用缓存的静态资源url
    generateStaticUrl: (url) => {
        return `${url}?r=${Math.random()}`
    },
    //發送提示
    alert: (text, type) => {
        ElMessage({
            showClose: true,
            message: text,
            type: type,
            // appendTo: proxy.$refs.cardview,
            offset: 180
        })
    },
    //發送成功提示
    alertSuccess: (text) => {
        myUtil.alert(text, "success")
    },
    //發送成功提示
    alertWarning: (text) => {
        myUtil.alert(text, "warning")
    },
    //發送成功提示
    alertInfo: (text) => {
        myUtil.alert(text, "info")
    },
    //發送成功提示
    alertError: (text) => {
        myUtil.alert(text, "error")
    },
    //消息詢問框
    confirm: (text, type, sureFunc, cancelFunc) => {
        ElMessageBox.confirm(
            text,
            "提示",
            {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: type,
                // center: true,
            }
        )
            .then(() => {
                if (typeof sureFunc === "function"){
                    sureFunc()
                }
            })
            .catch(() => {
                if (typeof cancelFunc === "function"){
                    cancelFunc()
                }
            })
    },
    //成功詢問
    confirmSuccess: (text, sureFunc, cancelFunc) => {
        myUtil.confirm(text, "success", sureFunc, cancelFunc)
    },
    //信息詢問
    confirmInfo: (text, sureFunc, cancelFunc) => {
        myUtil.confirm(text, "info", sureFunc, cancelFunc)
    },
    //警告詢問
    confirmWarning: (text, sureFunc, cancelFunc) => {
        myUtil.confirm(text, "warning", sureFunc, cancelFunc)
    },
    //錯誤詢問
    confirmError: (text, sureFunc, cancelFunc) => {
        myUtil.confirm(text, "error", sureFunc, cancelFunc)
    },
    //是否是移動端
    isMobile: () => {
        return ('ontouchstart' in document.documentElement)
    },
    //获取不用缓存的名片图片url
    generateCardImgUrl: (cardinfo) => {
        return myUtil.generateStaticUrl(`${baseUrl.shopopee}MPic/ZZ/${cardinfo}`)
    },
    //获取不用缓存的名片图片相對路徑url
    generateCardImgRelativeUrl: (cardinfo) => {
        return myUtil.generateStaticUrl(`/MPic/ZZ/${cardinfo}`)
    },
    //獲取名片分享鏈接
    generateCardShareUrl: (id) => {
        return `${baseUrl.shopopee}receive?id=${id}`
    },
    //獲取名片whatsapp分享鏈接
    generateCardWhatsappShareUrl: (id) => {
        return `${baseUrl.shopopee}receive/whatsApp/${id}`
    },
    //獲取名片聊天分享鏈接
    generateCardChatShareUrl: (id) => {
        return `${baseUrl.shopopee}receive?id=${id}&isAllow=1&ischat=1`
    },
    //获取产品图片
    generateProductImg: (obj, randomNum) => {

        if (null == randomNum){
            randomNum = Math.random()
        }

        return `${baseUrl.SSL}://${obj.procedurename}/MPic/${obj.acccode}/${obj.productid.substring(0, 2)}/${obj.productid}.jpg?r=${randomNum}`
    },
    //檢查郵件格式
    emailCheck: (emailAddr) => {
        if((emailAddr == null) || (emailAddr.length < 2)) return false ;

        const aPos = emailAddr.indexOf("@" ,1) ;

        if(aPos < 0)
        {
            return false ;
        }

        if(emailAddr.indexOf("." ,aPos+2) < 0)
        {
            return false ;
        }

        return true ;
    },
    //日期格式化
    formatDate: (date, fmt) => {
        if (typeof date == 'string') {
            return date;
        }

        if (!fmt) fmt = "yyyy-MM-dd hh:mm:ss";

        if (!date || date == null) return null;
        const o = {
            'M+': date.getMonth() + 1, // 月份
            'd+': date.getDate(), // 日
            'h+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
            'S': date.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
        return fmt
    },
    addMonths(date, months) {
        let result = new Date(date);
        result.setMonth(result.getMonth() + months);
        return result;
    },
    //彈出式輸入框
    prompt: (options) => {
        const obj = {
            title: "請輸入",
            message: "",
            callback: () => {},
            cancelCallback: () => {},
            pattern: null,
            inputErrorMessage: null
        }

        myUtil.mergeObj(options, obj)

        ElMessageBox.prompt(obj.message, obj.title, {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            inputPattern: obj.pattern,
            inputErrorMessage: obj.inputErrorMessage,
        })
            .then(({ value }) => {
                obj.callback(value)
            })
            .catch(() => {
                obj.cancelCallback()
            })
    },
    //計算文件大小文字
    calcFileSize: (size) => {
        size = Number(size)
        if (size < 1000){
            return `${size} B`
        }else if(size < 1000000){
            size = myUtil.toDecimal2(size / 1024.0)
            return `${size} KB`
        }else if (size < 1000000000){
            size = myUtil.toDecimal2(size / 10485760)
            return `${size} MB`
        }else{
            size = myUtil.toDecimal2(size / 1073741824)
            return `${size} GB`
        }
    },
    //保留兩位小數
    toDecimal2: (x) => {
        let f = parseFloat(x);

        if (isNaN(f)) {
            return false;
        }

        f = Math.round(x*100)/100;

        let s = f.toString();
        let rs = s.indexOf('.');

        if (rs < 0) {
            rs = s.length;
            s += '.';
        }

        while (s.length <= rs + 2) {
            s += '0';
        }

        return Number(s);
    },
    //rgb转16进制颜色
    "rgbToHexColor": (rgb) => {
        rgb = rgb.replaceAll("rgb(", "")
        rgb = rgb.replaceAll(")", "")
        rgb = rgb.replaceAll(" ", "")

        const list = rgb.split(",")
        const r = parseInt(list[0])
        const g = parseInt(list[1])
        const b = parseInt(list[2])

        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)

    },
    //生成EShopopee产品图片
    generateEShopopeeProductImg: (obj) => {
        return `${baseUrl.SSL}://${baseUrl.eshopopee}/MPic/${obj.CompanyCode}/${obj.ProductID.substring(0, 2)}/${obj.ProductID}.jpg?r=${Math.random()}`
    },
    //浮點數運算
    MathFix: (num1, num2, symbol) => {
        var str1=num1.toString(),str2=num2.toString(),result,str1Length,str2Length
        //解決整數沒有小數點
        try {str1Length= str1.split('.')[1].length} catch (error) {str1Length=0}
        try {str2Length= str2.split('.')[1].length} catch (error) {str2Length=0}

        var step=Math.pow(10,Math.max(str1Length,str2Length))

        var calcNum1 = Math.floor(num1 * step)
        var calcNum2 = Math.floor(num2 * step)

        switch (symbol) {
            case "+":
                result = ( calcNum1 + calcNum2 ) / step
                break;
            case "-":
                result = ( calcNum1 - calcNum2 ) / step
                break;
            case "*":
                result = (calcNum1 * calcNum2) / step / step
                break;
            case "/":
                result = calcNum1 / calcNum2
                break;
            default:
                break;
        }
        return result

    },
    //生成激活鏈接
    generateActivateUrl: (id, code) => {
        let url = `http://127.0.0.1:8080/activate?id=${id}&code=${code}`

        if (process.env.NODE_ENV === 'production'){
            url = `${baseUrl.shopopee}activate?id=${id}&code=${code}`
        }

        return url
    },
    //获取url参数
    getUrlValue: (value) => {
        let url = window.location.search
        let reg = new RegExp("(^|&)" + value + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        let values = url.substring(1).match(reg);
        if (null == values || "" == values || undefined == values){
            return null
        }else{
            return values[2]
        }
    },
    //生成eshopopee前台鏈接
    generateEShopopeeShopUrl: (acccompanycode, host) => {
        if (null == host){
            host = baseUrl.eshopopee
        }

        return `${baseUrl.SSL}://${host}/Web/W006/index.asp?companyCode=${acccompanycode}&formUrl=3dshop`
    },
    //生成eshopopee登錄後跳轉的後台鏈接
    generateEshopopeeManagerJumpUrl: (acccompanycode, login, password, redirectLink, host) => {
        if (null == host){
            host = baseUrl.eshopopee
        }

        return `${baseUrl.SSL}://${host}/ControlCenter/LoginCheck.asp?SelectCompanyCode=${acccompanycode}&Email=${login}&Password=${password}&redirectLink=${redirectLink}`
    },
    //生成eshopopee後台鏈接
    generateEshopopeeManagerUrl: (acccompanycode, login, password, host) => {
        if (null == host){
            host = baseUrl.eshopopee
        }

        return `${baseUrl.SSL}://${host}/ControlCenter/LoginCheck.asp?SelectCompanyCode=${acccompanycode}&Email=${login}&Password=${password}&shopForm=shopopee`
    },
    //生成eshopopee產品鏈接
    generateEshopopeeProductPageUrl: (obj) => {
        return `${baseUrl.SSL}://${obj.procedurename}/Web/W006/single_product.asp?productID=${obj.productid}&ProductCompanyCode=${obj.acccode}&CompanyCode=${obj.acccode}&formUrl=3dshop`
    },
    //生成產品鏈接
    generateProductInfoUrl: (productid) => {
        return `${baseUrl.shopopee}productInfo?id=${productid}`
    },
    //保存管理员的个人信息
    saveAdminMemberInfo: (userInfo, adminInfo, newInfo) => {
        adminInfo.id = userInfo.id
        adminInfo.companycode = userInfo.companycode
        adminInfo.acccompanycode = userInfo.acccompanycode
        adminInfo.login = userInfo.login
        adminInfo.password = userInfo.password
        adminInfo.addinfo7 = userInfo.addinfo7
        adminInfo.country = userInfo.country
        adminInfo.token = userInfo.token
        adminInfo.businessId = userInfo.id
        adminInfo.businessLogin = userInfo.login
        adminInfo.businessPassword = userInfo.password

        userInfo.id = newInfo.id
        userInfo.companycode = newInfo.companycode
        userInfo.acccompanycode = newInfo.acccompanycode
        userInfo.login = newInfo.login
        userInfo.password = newInfo.password
        userInfo.addinfo7 = newInfo.addinfo7
        userInfo.country = newInfo.country
        userInfo.token = newInfo.token
        userInfo.businessId = newInfo.id
        userInfo.businessLogin = newInfo.login
        userInfo.businessPassword = newInfo.password
    },
    //加载管理员的个人信息
    loadAdminMemberInfo: (userInfo, adminInfo) => {
        userInfo.id = adminInfo.id
        userInfo.companycode = adminInfo.companycode
        userInfo.acccompanycode = adminInfo.acccompanycode
        userInfo.login = adminInfo.login
        userInfo.password = adminInfo.password
        userInfo.addinfo7 = adminInfo.addinfo7
        userInfo.country = adminInfo.country
        userInfo.token = adminInfo.token
        userInfo.businessId = adminInfo.id
        userInfo.businessLogin = adminInfo.login
        userInfo.businessPassword = adminInfo.password

        adminInfo.$reset()
    },
    //打開新窗口
    goURLNewWindow: (url, tag) => {
        const window2 = window.open("", tag)

        setTimeout(() => {
            window2.location.href = url
        }, 1000)
    },
    //使用相對路徑生成圖片鏈接
    generateImgUrlByRelativePath: (path) => {
        return `${baseUrl.shopopee}${path}`
    },
    //字符串base64編碼
    encoderBase64Str: (text) => {
        let encoder = new TextEncoder();
        let data = encoder.encode(text);
        let encodedData = btoa(String.fromCharCode.apply(null, Array.from(data)));
        console.log(text)
        console.log(myUtil.decodedBase64Str(encodedData))
        return encodedData
    },
    //base64字符串解碼
    decodedBase64Str: (base64) => {
        let decodedData = atob(base64);
        let decoder = new TextDecoder();
        let decodedString = decoder.decode(new Uint8Array(Array.from(decodedData).map(c => c.charCodeAt(0))));
        return decodedString
    },
    //數字轉保留兩位金額字符串
    toDecimal2Str: (num) => {
        num = Number(num)

        if (num % 1 > 0){
            num = num * 100

            if (num % 1 > 0){
                num += 1
                num = Math.floor(num)
            }

            num /= 100
        }else{
            num = `${Math.floor(num)}.00`
        }

        return num
    },
    //生成eshopopee登錄並跳轉的鏈接
    generateEshopopeeLoginAndJumpUrl: (path, login, password, params) => {
        const obj = {
            account: {
                login: login,
                password: password
            },
            path: path,
            params: params
        }

        return `${baseUrl.SSL}://${baseUrl.eshopopee}/3d/page/${myUtil.encoderBase64Str(JSON.stringify(obj))}`
    },
    //生成youtube視頻封面鏈接
    generateYoutubeCoverByUrl: (url) => {
        let link = ""
        if (myUtil.isNotEmpty(url)){
            let key = ""

            if (url.indexOf("embed") != -1){
                const startIndex = url.lastIndexOf("/")
                const endIndex = url.indexOf("?")

                if (endIndex == -1){
                    key = url.substring(startIndex + 1)
                }else{
                    key = url.substring(startIndex + 1, endIndex)
                }

            }else if(url.indexOf("?v=") != -1){
                const index = url.lastIndexOf("?v=")
                key = url.substring(index + 3)
            }else{
                const startIndex = url.lastIndexOf("/")
                const endIndex = url.indexOf("?")

                if (endIndex == -1){
                    key = url.substring(startIndex + 1)
                }else{
                    key = url.substring(startIndex + 1, endIndex)
                }
            }

            link = `https://i.ytimg.com/vi/${key}/hqdefault.jpg`
        }

        return link
    }
}

export default myUtil